export default __webpack_public_path__ + "static/media/menu-profile-money.80c86d01.svg";